(function () {
    'use strict';

    angular
        .module('app.addPostToCampaigns', [])
        .factory('addPostToCampaignsService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                    return data;
                }

                function getMessage(data) {
                    if (data) {
                        return data.message;
                    }
                    return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req)
                        .success(function (data) {
                            var dataRes = angular.fromJson(data);

                            if (checkResponse(dataRes)) {
                                deferred.resolve(dataRes);
                            } else {
                                deferred.reject(getMessage(dataRes));
                            }
                        })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getAvailableCampaignsToAddPost(company_id, url_hash) {
                    var url = $rootScope.apiUrl + 'campaign/' + company_id + '/getAvailableCampaignsToAddPost/' + url_hash;
                    return handleRequest(url, 'GET', null, true);
                }

                function addPostToCampaigns(data) {
                    var url = $rootScope.apiUrl + 'campaign/addPostToCampaigns';
                    return handleRequest(url, 'POST', data, true);
                }

                service.getAvailableCampaignsToAddPost = getAvailableCampaignsToAddPost;
                service.addPostToCampaigns = addPostToCampaigns;

                return service;
            }
        ]);
})();
